import { LEGAL_CONTACT_EMAIL_DEFAULT } from '@constants/legal';
import type { SiteSettings } from '@lambda/shared/types';

/** Director contact for footer, Terms, Privacy, and maintenance fallback. */
export function resolveDirectorEmail(settings: SiteSettings | null | undefined): string {
  const fromSettings = settings?.directorEmail?.trim();
  if (fromSettings && fromSettings.length > 0) {
    return fromSettings;
  }
  return LEGAL_CONTACT_EMAIL_DEFAULT;
}
